import { render, staticRenderFns } from "./ComplaintTelList.vue?vue&type=template&id=82a86226&scoped=true&"
import script from "./ComplaintTelList.vue?vue&type=script&lang=js&"
export * from "./ComplaintTelList.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintTelList.vue?vue&type=style&index=0&id=82a86226&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a86226",
  null
  
)

export default component.exports